{
	"title": "Something went wrong",
	"subtitle": "Error code",
	"description": "Our team has already been notified of the error. Please reload the page and try again.",
	"descriptionWithError": "If the problem is recurring, let our team know the code above."
}
